var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',[_vm._v(_vm._s(_vm.status))]),_c('br'),_c('input',{attrs:{"type":"file","name":"files","id":"csv-file"},on:{"change":_vm.handleFileSelect}})])}
var staticRenderFns = []

export { render, staticRenderFns }